import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Router } from '@angular/router'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import { ButtonComponent } from '../button/button.component'
import { AnalyticsService } from 'app/services/analytics.service'

@Component({
  selector: 'app-footer-newgalleries',
  templateUrl: './footer-newgalleries.component.html',
  styleUrl: './footer-newgalleries.component.scss',
  standalone: true,
  imports: [ CommonModule, TranslateModule, ButtonComponent ]
})
export class FooterNewgalleriesComponent {
  @Input() isFormValid: boolean = false;
  @Output() publish = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();
  @Input() creating = false;

  constructor(private router: Router, private analytics: AnalyticsService) {}

  goBack(): void {
    this.router.navigate(['/my-galleries']);
  }

  onClick() {
    if (this.isFormValid) {
      this.publish.emit();
      this.analytics.trackClick('publish-gallery');
    }
  }
}
